export const skillsData = {
  frontend: [
    { name: "React.js", level: "Advanced", icon: "DiReact", color: "#61dafb" },
    { name: "JavaScript (ES6+)", level: "Advanced", icon: "DiJavascript1", color: "#f7df1e" },
    { name: "Next.js", level: "Intermediate", icon: "SiNextdotjs", color: "#ffffff" },
    { name: "Tailwind CSS", level: "Advanced", icon: "SiTailwindcss", color: "#38bdf8" },
    { name: "HTML5 / CSS3", level: "Advanced", icon: "DiHtml5", color: "#e34f26" },
    { name: "Bootstrap", level: "Advanced", icon: "DiBootstrap", color: "#7952b3" }
  ],
  backend: [
    { name: "Node.js", level: "Advanced", icon: "DiNodejs", color: "#68a063" },
    { name: "Express.js", level: "Advanced", icon: "SiExpress", color: "#ffffff" },
    { name: "Django", level: "Intermediate", icon: "SiDjango", color: "#092e20" },
    { name: "Socket.IO", level: "Advanced", icon: "SiSocketdotio", color: "#010101" },
    { name: "MongoDB", level: "Advanced", icon: "DiMongodb", color: "#47a248" },
    { name: "PostgreSQL", level: "Intermediate", icon: "SiPostgresql", color: "#336791" },
    { name: "Redis", level: "Familiar", icon: "SiRedis", color: "#dc382d" },
    { name: "Firebase", level: "Intermediate", icon: "SiFirebase", color: "#ffca28" }
  ],
  languages: [
    { name: "C++", level: "Advanced", icon: "CgCPlusPlus", color: "#00599c" },
    { name: "JavaScript", level: "Advanced", icon: "DiJavascript1", color: "#f7df1e" },
    { name: "Python", level: "Advanced", icon: "DiPython", color: "#3776ab" },
    { name: "Golang", level: "Intermediate", icon: "TbBrandGolang", color: "#00add8" },
    { name: "Java", level: "Intermediate", icon: "DiJava", color: "#ea2d2e" },
    { name: "Solidity", level: "Familiar", icon: "SiSolidity", color: "#656565" }
  ],
  tools: [
    { name: "Git & GitHub", level: "Advanced", icon: "DiGit", color: "#f05032" },
    { name: "VS Code", level: "Advanced", icon: "SiVisualstudiocode", color: "#007acc" },
    { name: "Postman", level: "Advanced", icon: "SiPostman", color: "#ff6c37" },
    { name: "Vercel", level: "Advanced", icon: "SiVercel", color: "#ffffff" },
    { name: "Linux / macOS", level: "Intermediate", icon: "SiMacos", color: "#ffffff" },
    { name: "Slack / Teams", level: "Advanced", icon: "SiSlack", color: "#4a154b" }
  ]
};

export const educationData = [
  {
    degree: "Bachelor of Computer Applications (BCA)",
    institution: "ITM University, Gwalior",
    duration: "2023 - 2026",
    description: "Specialized in Computer Science, Data Structures & Algorithms, Object-Oriented Programming, and Full Stack Web Application Development.",
    badge: "Graduate"
  }
];

export const hobbiesData = [
  { title: "Building Side Projects", icon: "🚀", desc: "Experimenting with modern tech stacks & tools" },
  { title: "Writing Tech Content", icon: "✍️", desc: "Sharing learnings about JavaScript and backend systems" },
  { title: "Gaming & Strategy", icon: "🎮", desc: "Unwinding with competitive strategy games" },
  { title: "Exploring AI & Web3", icon: "🧠", desc: "Keeping up with bleeding-edge AI models & decentralized tech" }
];
